export const BILLS_REQUEST = "BILLS_REQUEST";
export const BILLS_SUCCESS = "BILLS_SUCCESS";
export const BILLS_ERROR = "BILLS_ERROR";